module.exports = __webpack_public_path__ + "media/images/icons/outlined/coffee-8a6afa5849eb2a00f97357753d299255.svg";